import {ServicesContext, ServiceHook, ServiceMap} from './type';
import {useContext} from 'preact/hooks';

export default function createServiceHook<State, CommandTypes, EventTypes, Services extends ServiceMap<State, CommandTypes, EventTypes>>(
  serviceContext: ServicesContext<State, CommandTypes, EventTypes, Services>
): ServiceHook<State, CommandTypes, EventTypes, Services> {
  return () => useContext(serviceContext);
}